export const FIND_PRODUCTS_BY_ID_CATEGORY_AND_SIZE = "FIND_PRODUCTS_BY_ID_CATEGORY_AND_SIZE"
export const FIND_PRODUCTS_BY_ID_CATEGORY_AND_SIZE_SUCCESS = "FIND_PRODUCTS_BY_ID_CATEGORY_AND_SIZE_SUCCESS"

export const FIND_PRODUCTS_BY_ID_CATEGORY_AND_SIZE_API_ERROR = "FIND_PRODUCTS_BY_ID_CATEGORY_AND_SIZE_API_ERROR"
